import client from './client';

const API_URL = '/api/templates';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { 'Authorization': `Bearer ${token}` } : {};
};

export const fetchTemplates = async ({ subject, grade } = {}) => {
    try {
        const params = {};
        if (subject) params.subject = subject;
        if (grade) params.grade = grade;
        const response = await client.get(API_URL, {
            headers: getAuthHeaders(),
            params,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching templates:', error);
        throw error;
    }
};

export const fetchTemplate = async (templateId) => {
    try {
        const response = await client.get(`${API_URL}/${templateId}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching template ${templateId}:`, error);
        throw error;
    }
};

export const fetchTemplateVersion = async (versionId) => {
    try {
        const response = await client.get(`${API_URL}/version/${versionId}`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching template version ${versionId}:`, error);
        throw error;
    }
};

export const createTemplate = async (content) => {
    try {
        const response = await client.post(API_URL, { content }, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error('Error creating template:', error);
        throw error;
    }
};

export const updateTemplate = async (templateId, content) => {
    try {
        const response = await client.put(`${API_URL}/${templateId}`, { content }, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating template ${templateId}:`, error);
        throw error;
    }
};

export const fetchTemplateHistory = async (templateId) => {
    try {
        const response = await client.get(`${API_URL}/${templateId}/history`, {
            headers: getAuthHeaders(),
        });
        return response.data;
    } catch (error) {
        console.error(`Error fetching template history ${templateId}:`, error);
        throw error;
    }
};
